/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
const NotificationsCtrl = function (NotificationsService) {
  this.notifications = NotificationsService.notifications;
};

module.exports = NotificationsCtrl;
